import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseModels_Vehicle_VehicleBrandResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetVehicleBrands = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
};
/**
 * Returns a list of possible vehicle brands
 *
 * @returns ResponseModels_Vehicle_VehicleBrandResponseModel Success
 */
export function getVehicleBrands(
  { businessUnit, label }: GetVehicleBrands,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Vehicle_VehicleBrandResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/compatibility-check/vehicle-brands`,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
